import React from 'react';
import { Button, Dialog, Flex, Label, Toast } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import Icons from "../Icons.js";
const {
  t,
  tIcon
} = I18N.ns('apiAccessKeyManagement.apiAccessKey.ViewAssociatedIdsDialog');
export default function ViewAssociatedIdsDialog(props) {
  const {
    delegate,
    variants,
    onClose,
    show
  } = props;
  const onCopyToClipboard = (name, value) => {
    navigator.clipboard.writeText(value);
    Toast.success([t('clipboard', {
      name,
      interpolation: {
        escapeValue: false
      }
    })]);
  };
  const onCopySystemId = ({
    data
  }) => {
    onCopyToClipboard(t('systemId'), data);
  };
  const onCopyDeviceId = ({
    data
  }) => {
    const name = delegate.getItem().name;
    onCopyToClipboard(`${name} ID`, data);
  };
  return /*#__PURE__*/React.createElement(Dialog.Message, {
    show: show,
    onClose: onClose,
    title: t('title'),
    icon: tIcon('removeDialogIcon', Icons.apiAccessKeyAssociatedIdsDialogIcon),
    okay: t('okayLabel'),
    okayVariant: "primary",
    onOkay: onClose
  }, /*#__PURE__*/React.createElement(Flex, {
    variant: "colL"
  }, /*#__PURE__*/React.createElement(Flex, {
    variant: "colS"
  }, /*#__PURE__*/React.createElement(Label, null, t('systemId')), /*#__PURE__*/React.createElement(Button, {
    variant: variants.copyToClipboardBig,
    eventData: delegate.systemId || delegate.id,
    onClick: onCopySystemId
  }, delegate.systemId || delegate.id)), delegate.systemId && /*#__PURE__*/React.createElement(Flex, {
    variant: "colS"
  }, /*#__PURE__*/React.createElement(Label, null, `${delegate.getItem().name} ID`), /*#__PURE__*/React.createElement(Button, {
    variant: variants.copyToClipboardBig,
    eventData: delegate.id,
    onClick: onCopyDeviceId
  }, delegate.id))));
}